import React, {Component} from 'react';
import {INTEREST} from "../../constants";
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './carousel-override.css';
import './interest.css';
import Phone from '../Phone/Phone';
import GroupFigures from '../GroupFigures/GroupFigures';
import {Carousel} from 'react-responsive-carousel';
import archive from './archive.svg';
import pen from './pen.svg';
import sharp from './sharp.svg';
import marker from './map-marker.svg';
import classNames from 'classnames';

const icons = [marker, sharp, pen, archive];

class Interest extends Component {
	constructor() {
		super();
		this.state = {width: 1920}
	}

	updateDimensions = () => {
		this.setState({width: document.body.clientWidth});
	};

	componentWillMount() {
		this.updateDimensions();
	}

	componentDidMount() {
		window.addEventListener("resize", this.updateDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions);
	}

	render() {
		const {selectedItem, onChangeSelectedItem} = this.props;
		const {width} = this.state;
		return (
			<div className="interest">
				<div className="interest__animation">
					<Phone indexImages={selectedItem}/>
					<GroupFigures shape={selectedItem}/>
					{icons.map((icon, index) => {
						const classIcon = classNames({
							'interest__icons': true,
							[`interest__icons--${index}`]: true,
							[`interest__icons--active`]: index === selectedItem
						});
						return (<img key={'interest-icon-' + icon}
						             src={icon}
						             className={classIcon}
						             alt="interest icon"/>)
					})}
				</div>
				<div className="interest__item">
					<Carousel
						onChange={onChangeSelectedItem}
						className="interest-carousel"
						showArrows={false}
						showThumbs={false}
						showStatus={false}
						showIndicators={false}
						useKeyboardArrows={true}
						swipeScrollTolerance={0}
						axis={width >= 768 ? 'vertical' : 'horizontal'}
						selectedItem={selectedItem}
						emulateTouch
						children={INTEREST.map((item, index) => {
							return (
								<div key={'interest-' + item.title}>
									<h3 className="interest__title">{item.title}</h3>
									<div className="interest__text">{item.text}</div>
								</div>
							)
						})}>
					</Carousel>
				</div>
			</div>
		);
	}
}

export default Interest;



// WEBPACK FOOTER //
// ./src/components/Interest/Interest.js